import ApiService from '../../../../shared/services/ApiService';

export default {


    updateCompanySettings(data) {
        return ApiService.post('company-settings', data);
    }
}